import Button from 'components/Button'
import { FileDataProps } from 'containers/Onboarding'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface IProgressReport {
  file?: FileDataProps
  onClose: () => void
  setSteps: () => void
}

export const ProgressReport: React.FC<IProgressReport> = (props) => {
  const { t } = useTranslation(['common', 'onboarding'])

  const { file, onClose } = props
  const base = 'con-modal-progress-report'

  const renderMbOrKb = (fileSize: number) => {
    const byte = 1048576
    const Mb = fileSize * 0.000001
    const Kb = fileSize * 0.001

    if (fileSize >= byte) {
      return `${Mb.toFixed(2)} MB`
    } else {
      return `${Kb.toFixed(2)} KB`
    }
  }

  return (
    <div className={`${base}`}>
      <div>
        <div className={`${base}__title`}>
          <span className={`${base}__title-text`}>
            {t('onboarding:progress.report.title1')}
          </span>
          <span className={`${base}__title-text`}>
            {t('onboarding:progress.report.title2')}
          </span>
        </div>
        <div className={`${base}__detail`}>
          <span className={`${base}__detail-title`}>
            {t('onboarding:progress.report.file.upload')}
          </span>
          <span className={`${base}__detail-data`}>
            {file ? file?.name : '...'}
          </span>
        </div>
        <span className={`${base}__size`}>
          {t('onboarding:progress.report.file.upload.size')}{' '}
          {file ? renderMbOrKb(file?.size) : '...'}
        </span>
        <div className={`${base}__button-group`}>
          <Button onClick={onClose}> {t('common:close.button')}</Button>
        </div>
      </div>
    </div>
  )
}
